// extracted by mini-css-extract-plugin
export var createdDate = "_j2-1";
export var divider = "_j2-2";
export var headerDivider = "_j2-3";
export var messagesCard = "_j2-0";
export var messagesContainer = "_j2-7";
export var messagesContainerWrapper = "_j2-4";
export var pointerCapturingButtonBoxes = "_j2-a";
export var showLeftPanelButton = "_j2-9";
export var showMoreButton = "_j2-c";
export var showMoreButtonContainer = "_j2-b";
export var summaryTitle = "_j2-6";
export var systemMessageCardWrapper = "_j2-d";
export var topButtons = "_j2-8";
export var withPadding = "_j2-5";